import { render, staticRenderFns } from "./CustomerDetailsForm.vue?vue&type=template&id=e09f8e24"
import script from "./CustomerDetailsForm.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailsForm.vue?vue&type=style&index=0&id=e09f8e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports